import { SignUpContent } from '@/lib/auth'

export function SignupPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10">
      <div className="w-full max-w-md space-y-8 rounded-xl bg-card p-8 shadow-lg">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-primary">Context Harness</h1>
          <p className="mt-2 text-muted-foreground">
            コンテキスト管理プラットフォーム
          </p>
        </div>
        <SignUpContent />
      </div>
    </div>
  )
}
